import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const AdminProtectedRoute = ({ children }) => {
    const { user, loading } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) {
            // Ne rien faire tant que le chargement est en cours
            return;
        }

        if (user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3') {
            // L'utilisateur est authentifié avec le bon rôle
        } else if (user) {
            console.log('Rôle incorrect, redirection vers /accessDenied');
            navigate('/accessDenied'); // Rediriger si rôle incorrect
        } else {
            console.log('Non authentifié, redirection vers /login');
            navigate('/login'); // Rediriger vers la page de login si non authentifié
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <div>Loading...</div>; // Afficher un écran de chargement si les données sont en cours de récupération
    }

    return children;
};

export default AdminProtectedRoute;
